import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './index.css';
import { useCookies } from 'react-cookie';
import logoMinervaBianco from '../../images/logo-minerva-bianco.svg';
import logoEuBianco from '../../images/logo-eu-su-blu.svg';
import logoDfpBianco from '../../images/funzione-pubblica-su-blu.svg';
import history from '../../utils/history';
import themeColors from '../../utils/contants/theme-colors';

const accessoSviluppo = process.env.REACT_APP_ACCESSO_SVILUPPO;
const accessoPua = process.env.REACT_APP_ACCESSO_PUA;
const accessoEidas = process.env.REACT_APP_ACCESSO_EIDAS;
const urlAccessoPua = process.env.REACT_APP_URL_ACCESSO_PUA;

function HeaderHtml() {
  const [cookies] = useCookies(['cookie-name']);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Aggiornamento per ridimensionamento della finestra
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determina il link di accesso in base alle variabili d'ambiente
  const getAccessLink = () => {
    // Se l'utente è già loggato, torna sempre all'area riservata
    if (cookies.loggedIn) {
      return '/area-riservata/scelta-identita';
    }

    // Se PUA è attivo e sviluppo ed EIDAS sono disattivati, vai direttamente all'URL PUA
    if (accessoPua === 'true' && accessoSviluppo !== 'true' && accessoEidas !== 'true') {
      return urlAccessoPua;
    }

    // Altrimenti vai alla pagina-login
    return '/pagina-login';
  };

  const accessLink = getAccessLink();
  const isExternalLink = accessLink.startsWith('http');

  return (
    <header className="it-header-wrapper header-shadow">
      <div className="it-header-slim-wrapper" style={{ backgroundColor: themeColors.secondary, borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-header-slim-wrapper-content">
                <a
                  className="d-lg-block navbar-brand text-white"
                  href="http://www.funzionepubblica.gov.it/"
                  target="_blank"
                  rel="noreferrer"
                  title="Collegamento a sito esterno - Dipartimento della funzione pubblica - si apre una nuova finestra"
                  aria-label="Dipartimento della Funzione Pubblica"
                >
                  Dipartimento della funzione pubblica
                </a>
                <div className="it-access-top-wrapper">
                  {cookies.loggedIn
                    ? (
                      <Link className="btn btn-outline-secondary rounded-2 btn-full text-white" to="/area-riservata/scelta-identita" title="Torna all'area riservata">
                        <FontAwesomeIcon aria-hidden="true" icon={['fas', 'user-circle']} size="lg" />
                        &nbsp;
                        <span className="d-none d-md-inline">Torna all&apos;area riservata</span>
                      </Link>
                    )
                    : (
                      isExternalLink ? (
                        <a className="btn btn-outline-secondary text-white btn-full rounded-2" href={accessLink} title="Accedi all'area riservata">
                          <FontAwesomeIcon aria-hidden="true" icon={['fas', 'user-circle']} size="lg" />
                          &nbsp;
                          Accedi
                          <span className="d-none d-md-inline">&nbsp;all&apos;area riservata</span>
                        </a>
                      ) : (
                        <Link className="btn btn-outline-secondary text-white btn-full rounded-2" to={accessLink} title="Accedi all'area riservata">
                          <FontAwesomeIcon aria-hidden="true" icon={['fas', 'user-circle']} size="lg" />
                          &nbsp;
                          Accedi
                          <span className="d-none d-md-inline">&nbsp;all&apos;area riservata</span>
                        </Link>
                      )
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-nav-wrapper">
        <div className="it-header-center-wrapper" style={{ backgroundColor: themeColors.secondary }}>
          <div className="container">
            <div className="row h-100">
              <div className="col-12 h-100">
                <div className="it-header-center-content-wrapper d-flex align-items-center justify-content-start gap-4 h-100">
                  <div className="it-brand-wrapper ps-0 gap-2 d-flex align-items-center justify-content-start h-100">
                    <button className="custom-navbar-toggler px-0" type="button" aria-controls="nav4" aria-expanded="false" aria-label="Mostra/Nascondi la navigazione" data-bs-toggle="navbarcollapsible" data-bs-target="#nav4">
                      <svg className="bg-override"><use href="/navbar-icons/sprites.svg#it-burger" /></svg>
                    </button>
                    <Link to="/" title="Vai alla pagina: Homepage" className="d-flex align-items-center h-100">
                      <svg className="icon" aria-hidden="true">
                        <image xlinkHref={logoMinervaBianco} alt="Logo Minerva" />
                      </svg>
                    </Link>
                  </div>
                  <div className="d-flex align-items-center h-100 gap-3">
                    <div className="d-none d-lg-block" style={{ width: '2px', height: '60px', backgroundColor: 'rgba(255,255,255,0.3)' }} />
                    <div className="d-none d-lg-flex align-items-center gap-3">
                      <img height="55px" src={logoEuBianco} alt="Logo Next Generation EU" />
                      <img height="55px" src={logoDfpBianco} alt="Logo DFP" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="it-header-navbar-wrapper theme-dark" style={windowWidth >= 992 ? { backgroundColor: themeColors.secondary } : {}}>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav
                  className="navbar navbar-expand-lg has-megamenu"
                  style={{ padding: '0 6px' }}
                  aria-label="Navigazione principale"
                >
                  <div
                    className="navbar-collapsable"
                    id="nav4"
                    style={{
                      display: 'none',
                      zIndex: 101,
                    }}
                  >
                    <div className="overlay" style={{ display: 'none' }} />
                    <div
                      className="menu-wrapper d-flex flex-column flex-lg-row"
                    >
                      <div
                        className="it-brand-wrapper d-lg-none"
                        style={{
                          padding: '24px',
                          borderBottom: '1px solid rgba(0, 89, 179, 0.2)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Link to="/" title="Vai alla pagina: Homepage" className="d-flex align-items-center text-decoration-none" style={{ marginRight: 'auto' }}>
                          <img
                            src={logoMinervaBianco}
                            alt="Logo Minerva"
                            style={{ height: '48px', width: 'auto', objectFit: 'contain' }}
                          />
                        </Link>
                        <button
                          className="btn close-menu "
                          type="button"
                          data-bs-toggle="navbarcollapsible"
                          data-bs-target="#nav4"
                          aria-controls="nav4"
                          aria-label="Nascondi la navigazione"
                        >
                          <span className="visually-hidden">Nascondi la navigazione</span>
                          <svg className="icon">
                            <use href="/navbar-icons/sprites.svg#it-close-big" />
                          </svg>
                        </button>
                      </div>
                      <ul className="navbar-nav">
                        {windowWidth < 992 && (
                          <li className="nav-item">
                            <Link
                              style={{
                                fontSize: '24px',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                lineHeight: '24px',
                                marginBottom: '16px',
                              }}
                              className={`nav-link ${history.location.pathname === '/' ? 'active underline ' : ''} text-white`}
                              to="/"
                            >
                              <span className="fw-bold">
                                Homepage
                              </span>
                            </Link>
                          </li>
                        )}
                        <li className="nav-item">
                          <Link
                            style={windowWidth < 992 ? {
                              fontSize: '24px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: '24px',
                              marginBottom: '16px',
                            } : {}}
                            className={`nav-link ${history.location.pathname === '/programmazione-personale' ? 'active ' : ''} text-white`}
                            to="/programmazione-personale"
                          >
                            <span className="fw-bold">
                              Programmazione del Personale
                            </span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            style={windowWidth < 992 ? {
                              fontSize: '24px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: '24px',
                              marginBottom: '16px',
                            } : {}}
                            className={`nav-link ${history.location.pathname === '/sistema-professionale' ? 'active' : ''} text-white`}
                            to="/sistema-professionale"
                          >
                            <span className="fw-bold">
                              Sistema Professionale
                            </span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            style={windowWidth < 992 ? {
                              fontSize: '24px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: '24px',
                              marginBottom: '16px',
                            } : {}}
                            className={`nav-link ${history.location.pathname === '/area-amministrazioni' ? 'active' : ''} text-white`}
                            to="/area-amministrazioni"
                          >
                            <span className="fw-bold">
                              Area Amministrazioni
                            </span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            style={windowWidth < 992 ? {
                              fontSize: '24px',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              lineHeight: '24px',
                              marginBottom: '16px',
                            } : {}}
                            className={`nav-link ${history.location.pathname === '/approfondimenti' ? 'active ' : ''} text-white`}
                            to="/approfondimenti"
                          >
                            <span className="fw-bold">
                              Approfondimenti
                            </span>
                          </Link>
                        </li>
                      </ul>
                      <div
                        className="d-lg-none"
                        style={{
                          marginTop: 'auto',
                          marginBottom: '69px',
                          padding: '16px 24px',
                          borderTop: '1px solid rgba(0, 89, 179, 0.2)',
                        }}
                      >
                        <a
                          className="btn btn-full d-flex align-items-center justify-content-center"
                          href={accessLink}
                          title="Accedi all'area riservata"
                          style={{
                            backgroundColor: '#fff',
                            color: 'var(--color-primary)',
                            border: '2px solid var(--color-primary)',
                            padding: '12px 16px',
                            fontWeight: '600',
                            textDecoration: 'none',
                            borderRadius: '10px',
                          }}
                        >
                          <FontAwesomeIcon aria-hidden="true" icon={['fas', 'user-circle']} size="lg" />
                          <span style={{ marginLeft: '8px' }}>Accedi all&apos;area riservata</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default HeaderHtml;
